import { styled } from '@mui/material/styles';
import { Button, Box } from '@mui/material';

export const NavigationFooterContainer = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const PreviousButton = styled(Button)(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  backgroundColor: theme.palette.action.hover,
  border: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.secondary,
  borderRadius: theme.shape.borderRadius,
  textTransform: 'none',
  fontSize: '0.875rem',
  fontWeight: 500,
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
    borderColor: theme.palette.text.secondary,
    boxShadow: theme.palette.mode === 'dark' ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  '&:focus': {
    outline: `2px solid ${theme.palette.divider}`,
    outlineOffset: '2px',
  },
}));

export const NextButton = styled(Button)<{ disabled?: boolean }>(({ theme, disabled }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  background: disabled
    ? theme.palette.action.disabledBackground
    : 'linear-gradient(135deg, #06b6d4 0%, #10b981 100%)',
  color: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
  textTransform: 'none',
  fontSize: '0.875rem',
  fontWeight: 500,
  minWidth: '100px',
  border: 'none',
  '&:hover': {
    background: disabled
      ? theme.palette.action.disabledBackground
      : 'linear-gradient(135deg, #0891b2 0%, #059669 100%)',
    border: 'none',
  },
  '&:focus': {
    outline: 'none',
  },
  '&:disabled': {
    opacity: 0.5,
    cursor: 'not-allowed',
    background: theme.palette.action.disabledBackground,
    border: 'none',
  },
}));

export const EmptySpacer = styled(Box)(() => ({
  // Empty div to maintain layout with flex justify-between
}));

export const SaveDraftButton = styled(Button)(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  backgroundColor: theme.palette.action.hover,
  border: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.secondary,
  borderRadius: theme.shape.borderRadius,
  textTransform: 'none',
  fontSize: '0.875rem',
  fontWeight: 500,
  minWidth: '120px',
  marginRight: theme.spacing(1),
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
    borderColor: theme.palette.text.secondary,
    boxShadow: theme.palette.mode === 'dark' ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  '&:focus': {
    outline: `2px solid ${theme.palette.divider}`,
    outlineOffset: '2px',
  },
}));

export const ButtonsContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
}));
